/**
 * Run-level runner label for the execution log header. Derived from the
 * declared execution target of the graph's Task nodes (the authoritative
 * intent an author set in the editor):
 *   - `cloud`  — no Task node targets a local runner (the default)
 *   - `local`  — every Task node runs on a local runner
 *   - `mixed`  — the graph hands off between cloud and local runners
 *
 * Only Task nodes carry a `runnerTarget`; other computable kinds
 * (image_gen, 3d_gen, AUTO gates) always run in the cloud, so a graph
 * with no local Task nodes reads as `cloud`.
 */
export type RunnerLabel = 'cloud' | 'local' | 'mixed';

export function resolveRunnerLabel(
  nodes: readonly { type?: string; data?: unknown }[] | undefined,
): RunnerLabel {
  let hasLocal = false;
  let hasCloud = false;
  for (const node of nodes ?? []) {
    if (node.type !== 'task') continue;
    const target = (node.data as { runnerTarget?: unknown } | undefined)
      ?.runnerTarget;
    if (target === 'LOCAL') hasLocal = true;
    else hasCloud = true;
  }
  if (hasLocal && hasCloud) return 'mixed';
  if (hasLocal) return 'local';
  return 'cloud';
}
